export const encuestaFormModel = {
    formId: 'encuestaForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre de la Encuesta',
            requiredErrorMsg: 'El nombre es obligatorio'
        },
        description: {
            name: 'description',
            label: 'Descripción',
            requiredErrorMsg: 'La descripción es obligatoria'
        },
        type: {
            name: 'type',
            label: 'Tipo',
            requiredErrorMsg: 'El tipo es obligatorio'
        },
        areas_rating_id: {
            name: 'areas_rating_id',
            label: 'Área',
            requiredErrorMsg: 'El área es obligatoria'
        },
        questions: {
            name: 'questions',
            label: 'Preguntas',
            requiredErrorMsg: 'Debe agregar al menos una pregunta'
        },
        questionText: {
            name: 'questionText',
            label: 'Texto de la Pregunta',
            requiredErrorMsg: 'El texto de la pregunta es obligatorio'
        },
        isRequired: {
            name: 'isRequired',
            label: '¿Es obligatoria?',
        },
        isOpenQuestion: {
            name: 'isOpenQuestion',
            label: '¿Es pregunta abierta?',
        },
        openQuestionType: {
            name: 'openQuestionType',
            label: 'Formato de respuesta',
        },
        imgName: {
            name: 'imgName',
            label: 'Imagen (opcional)',
        },
        metricType: {
            name: 'metricType',
            label: 'Tipo de Métrica',
        },
        reviewLinks: {
            name: 'reviewLinks',
            label: 'Links de Reseñas',
        }
    }
};
